import React from 'react';
import { MapPin, Navigation, Phone } from 'lucide-react';

export default function Locations() {
  const locations = [
    {
      name: "Central Cleaners",
      address: "915 4th Street, Santa Rosa, CA 95405",
      phone: "(707) 843-7079",
      mapLink: "https://maps.google.com/?q=915+4th+Street,+Santa+Rosa,+CA+95405",
      embedUrl: "https://maps.google.com/maps?q=915+4th+Street,+Santa+Rosa,+CA+95405&t=&z=15&ie=UTF8&iwloc=&output=embed"
    },
    {
      name: "Bennett Valley Dry Cleaners",
      address: "2753 Yulupa Avenue, Santa Rosa, CA 95405",
      phone: "(707) 528-2152",
      mapLink: "https://maps.google.com/?q=2753+Yulupa+Ave,+Santa+Rosa,+CA+95405",
      embedUrl: "https://maps.google.com/maps?q=2753+Yulupa+Ave,+Santa+Rosa,+CA+95405&t=&z=15&ie=UTF8&iwloc=&output=embed"
    }
  ];

  return (
    <section id="locations" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2
            className="text-3xl md:text-4xl font-bold text-gray-900 mb-4"
            style={{
              color: "#6b7d5d"
            }}>Our Locations</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Conveniently located to serve the Santa Rosa community with two premium locations.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
          {locations.map((loc, index) => (
            <div key={index} className="flex flex-col h-full bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300 border border-gray-100">
              {/* Location Info */}
              <div className="p-8 pb-6">
                <div className="flex items-start justify-between mb-6">
                  <div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-2">{loc.name}</h3>
                    <div className="flex items-center gap-2 text-brand font-medium">
                      <MapPin size={18} />
                      <span>Santa Rosa, CA</span>
                    </div>
                  </div>
                  <div className="w-12 h-12 bg-brand/10 rounded-2xl flex items-center justify-center text-brand">
                    <MapPin size={24} />
                  </div>
                </div>

                <div className="space-y-4 mb-8">
                  <div className="flex items-start gap-3 text-gray-600">
                    <MapPin size={20} className="text-gray-400 shrink-0 mt-1" />
                    <p className="leading-relaxed">{loc.address}</p>
                  </div>
                  <div className="flex items-center gap-3 text-gray-600">
                    <Phone size={20} className="text-gray-400 shrink-0" />
                    <p>{loc.phone}</p>
                  </div>
                </div>

                <a 
                  href={loc.mapLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center w-full gap-2 py-3 px-6 bg-brand text-white rounded-xl font-semibold hover:bg-brand-dark transition-colors shadow-sm hover:shadow-md"
                >
                  <Navigation size={18} />
                  Get Directions
                </a>
              </div>

              {/* Map Embed */}
              <div className="flex-grow min-h-[300px] relative bg-gray-100 border-t border-gray-100">
                <iframe 
                  src={loc.embedUrl}
                  width="100%" 
                  height="100%" 
                  style={{ border: 0 }} 
                  allowFullScreen 
                  loading="lazy"
                  title={`${loc.name} Map`}
                  className="absolute inset-0 w-full h-full grayscale-[20%] hover:grayscale-0 transition-all duration-500"
                ></iframe>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
